import { useSortable } from "@dnd-kit/sortable";

function SortableItem({
    id,
    children,
    selectMode,
    selectedCardIds,
    setSelectedCardIds,
}) {
    const { attributes, listeners, setNodeRef, isDragging } = useSortable({ id });

    const isSelected = selectedCardIds.includes(id);

    
    return (
        <div
            className={`kanban-board-card ${isSelected ? 'selected' : ''}${isDragging ? 'dragging' : ''}${selectMode ? ' select-mode' : ''}`}
            ref={setNodeRef}
            {...(selectMode ? {} : { ...attributes, ...listeners })}
            onClick={selectMode ? (e) => {
                e.stopPropagation();
                setSelectedCardIds((prev) =>
                    prev.includes(id)
                        ? prev.filter((cid) => cid !== id)
                        : [...prev, id]
                );
            } : undefined}
        >
            {/* {selectMode && (
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => {
                        setSelectedCardIds((prev) =>
                            prev.includes(id)
                                ? prev.filter((cid) => cid !== id)
                                : [...prev, id]
                        );
                    }}
                    style={{ marginRight: 8 }}
                    onClick={e => e.stopPropagation()}
                />
            )} */}
            <span style={{wordBreak:"break-all"}}>
                {children?.content?.length > 100 ? children?.content?.slice(0, 100) + '...' : children?.content}
            </span>
            <div>
                <span className="parent">
                    {children?.parent?.length > 30 ? children?.parent?.slice(0, 20) + '...' : children?.parent}
                </span>
            </div>
            <div className="my-1">
                <p>{children?.totalHours}</p>
                <p>{children?.actualHours}</p>
                <div className="d-flex justify-content-between align-items-end">
                    <div style={{ fontSize: "13px" }}>{children?.issueKey}</div>
                    <div title={children?.user}><img className="rounded-circle" src={children?.image_url} alt="" width={25} height={25} /></div>
                </div>
            </div>
        </div>
    );
}

export default SortableItem;
